import { gql } from 'apollo-angular';

export const ResendEmailChangeDocument = gql(/* GraphQL*/ `mutation resendEmailChange
{
  resendEmailChange
}
`);
